var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleBgShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 504,
    height: 549,
    viewBox: "0 0 504 549",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M233.077 4C-61.6372 60.7144 -84.8923 533.097 238.881 544.781C557.266 556.273 591.359 112.727 303.271 36.3081M303.483 37.152C32.8515 14.6654 -103.09 420.511 176.105 509.672C450.654 597.352 588.976 219.271 356.721 82.4207",
    stroke: "#E2E2E2",
    strokeOpacity: 0.3,
    strokeWidth: 6.27,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleBgShape);
export default __webpack_public_path__ + "static/media/circle-bg-shape.ad12d35ec3411219fd8690ab3097061e.svg";
export { ForwardRef as ReactComponent };